<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat, text-xs-center)
            breadcrumb(back='page3-1')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero saber cómo me protege un Crédito Hipotecario!
            v-card-text.text-xs-center.label16tt.withDivider(style='color:#F7893B')
              | ESCENARIO
            v-layout(row, wrap, justify-start, py-4)
              v-flex.ma-0.pa-0(xs12, md6)
                v-card.pa-5(flat, height='100%', color='secondary')
                  v-card-text.parrafoDestacadoW.pl-5.py-3.mt-3
                    | Imagina que ya identificaste qué tipo de Crédito Hipotecario necesitas y que cumples con los requisitos para contratarlo.
                    .py-5 Estás a punto de dar el siguiente paso y de pronto surgen dudas sobre lo que podría pasar en el futuro.
                    v-icon.pr-3(color="white") fas fa-bolt
                    b Información para decidir:
                    .py-2.pl-4.ml-1 
                      i(style=("font-size:14px;")) Es conveniente que tanto tú como el otorgante del Crédito Hipotecario sean previsores.
              v-flex.ma-0.pa-0(xs12, md6)
                v-card(flat, text-xs-start)
                  v-card-media(height='600px', src='assets/TCH-L2-3-4--Pagina1A.jpg')
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button', color='accent', @click.prevent="nextPage('page3-3')")
                | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  }
};
</script>
